import _Select from "hzero-ui/lib/select";
import React, { forwardRef } from "react";
import "./css";
var WrappedSelect = forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(_Select, Object.assign({
    ref: ref
  }, props));
});
export default Object.assign(WrappedSelect, _Select);